<div class="titled-card-container">
  <div class="flex justify-between items-center mb-4">
    @if (title()) {
      <h1 class="text-2xl font-bold ml-2 h-10" [attr.data-testid]="titleTestId()">
        {{ title() }}
      </h1>
    } @else {
      <div class="grow"></div>
    }
    @if (actionLabel()) {
      <p-button
        [label]="actionLabel()"
        [disabled]="actionDisabled()"
        [styleClass]="actionStyleClass() + ' h-10'"
        [icon]="actionIcon()"
        [attr.data-testid]="actionTestId()"
        (onClick)="actionClick.emit()"
      ></p-button>
    }
  </div>
  <p-card [class]="styleClass()" [attr.data-testid]="testId()">
    <ng-content></ng-content>
  </p-card>
</div>
